import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComingSoon from "../components/ComingSoon";

function AutomationProList() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ComingSoon
        title="UDS Automation Pro"
        description="Unser leistungsstarkes Workflow-Automatisierungstool ist derzeit exklusiv für ausgewählte Testkunden verfügbar. Automation Pro ermöglicht es Ihnen, komplexe Geschäftsprozesse zu automatisieren, manuelle Aufgaben zu reduzieren und die Effizienz Ihres Unternehmens zu steigern. Die öffentliche Version wird bald für alle Kunden verfügbar sein."
        productUrl="https://www.unitas.cloud/produkte/automation"
      />
      <Footer />
    </DashboardLayout>
  );
}

export default AutomationProList;
